import React, { useRef, useState, useEffect, Suspense, lazy } from "react";
import { motion, useScroll, useMotionValueEvent, useInView } from "framer-motion";
import { Lines } from "../components/Reveal";

const SculptureCanvas = lazy(() => import("./SculptureCanvas"));

export default function Experience3D() {
    const ref = useRef(null);
    const progress = useRef(0);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const inView = useInView(ref, { margin: "40% 0px" });
    const [mounted, setMounted] = useState(false);

    useMotionValueEvent(scrollYProgress, "change", (v) => {
        progress.current = v;
    });

    useEffect(() => {
        if (inView) setMounted(true);
    }, [inView]);

    return (
        <section ref={ref} data-testid="experience-3d" data-cursor="DRAG" className="relative flex h-[110svh] items-center justify-center overflow-hidden bg-[#F2F0EA]">
            <div className="pointer-events-none absolute left-1/2 top-1/2 z-0 -translate-x-1/2 -translate-y-1/2">
                <div className="relative h-[68vmin] w-[68vmin]">
                    <div className="absolute inset-0 rounded-full bg-[radial-gradient(circle,rgba(10,10,10,0.09)_0%,rgba(10,10,10,0.03)_42%,transparent_68%)]" />
                    <div className="absolute inset-0 rounded-full border border-[rgba(10,10,10,0.1)]" />
                    <motion.div
                        className="absolute inset-6 rounded-full border border-dashed border-[rgba(10,10,10,0.07)]"
                        animate={{ rotate: 360 }}
                        transition={{ duration: 90, repeat: Infinity, ease: "linear" }}
                    />
                    <div className="absolute inset-16 rounded-full bg-[radial-gradient(circle,rgba(192,192,192,0.08)_0%,transparent_70%)]" />
                </div>
            </div>
            <div className="pointer-events-none absolute left-6 top-16 z-10 sm:left-16 sm:top-24">
                <p className="text-[9px] uppercase tracking-[0.4em] text-[#6B6A66]">02 — The Object</p>
            </div>
            <div className="pointer-events-none absolute right-6 top-16 z-10 text-right sm:right-16 sm:top-24">
                <p className="text-[9px] uppercase tracking-[0.4em] text-[#6B6A66]">Est. 2026</p>
            </div>
            <div className="pointer-events-none absolute bottom-16 left-1/2 z-10 -translate-x-1/2 text-center">
                <Lines
                    lines={["Vantage"]}
                    className="font-display text-[10vw] font-black uppercase leading-none tracking-tighter text-[rgba(10,10,10,0.14)] sm:text-[7vw]"
                />
                <p className="mt-4 text-[9px] uppercase tracking-[0.4em] text-[#6B6A66]">Own your perspective</p>
            </div>
            <div className="absolute inset-0">
                {mounted ? (
                    <Suspense
                        fallback={
                            <div className="flex h-full items-center justify-center">
                                <p className="text-[9px] uppercase tracking-[0.4em] text-[#333]">Loading object</p>
                            </div>
                        }
                    >
                        <SculptureCanvas progress={progress} />
                    </Suspense>
                ) : (
                    <div className="flex h-full items-center justify-center">
                        <div className="h-40 w-40 rounded-full bg-[radial-gradient(circle_at_35%_30%,#2a2a2c,#0a0a0a_70%)]" />
                    </div>
                )}
            </div>
        </section>
    );
}
